export default "__VITE_ASSET__BMYRWVcu__"